import Avatar from '@mui/material/Avatar';

import {
  formatPatientName,
  formatPatientInitials
} from '../../helpers/patients';

const PatientAvatar = ({patient, size = 40, ...props}) => (
  <Avatar
    {...props}
    alt={formatPatientName(patient)}
    size={size}
  >
    {formatPatientInitials(patient)}
  </Avatar>
);

export default PatientAvatar;